<template>
  <el-alert
    class="margb"
    type="info"
    :closable="false"
    :show-icon="false"
  >
    <template slot="title">
      <div class="title-wrapper">
        <template v-if="useDefault">
          <!-- 标题 -->
          <p class="title">
            {{ `${ defaultData[useDefaultNumber].title }` }}
          </p>
          <!-- 内容 -->
          <p class="description" v-for="(item, index) in defaultData[useDefaultNumber].description" :key="index">{{ item }}</p>
        </template>
        <template v-if="!useDefault && customContent">
          <!-- 标题 -->
          <p class="title">
            {{ `${ customContent.title }` }}
          </p>
          <!-- 内容 -->
          <p class="description" v-for="(item, index) in customContent.description" :key="index">{{ item }}</p>
        </template>
        <template v-if="!useDefault && !customContent && specialType">
          <!-- 标题 -->
          <p class="title">
            {{ specialTitle }}
          </p>
          <!-- 内容 -->
          <p class="description" v-for="(item, index) in specialDescription" :key="index">{{ item }}</p>
        </template>
      </div>
    </template>
  </el-alert>
</template>
<script>
const defaultData = {
  1: {
    title: '① 确认租赁信息',
    description: [
      '· 将根据“收款起止日期”进行各款项周期的应收拆分，请先如实填写后再确认支付计划；',
      '· 赠送的天数将在收款截止日期结束后赠送，合同的实际截止日期=收款截止日期+赠送天数。',
    ],
  },
  2: {
    title: '② 确认支付计划',
    description: [
      '· 纯租模式下，押金和租金为必填项，进入下一步前请先配置完成收款方案；',
      '· 收款项添加后会自动产生对应应收单。每一期的应收单会在收款起始日之前7天提前生成。',
    ],
  },
  3: {
    title: '① 确认租赁信息',
    description: [
      '· 赠送的天数将在收款截止日期结束后赠送，合同的实际截止日期=收款截止日期+赠送天数。',
    ],
  },
  4: {
    title: '② 确认支付计划',
    description: [
      '· 纯租模式下，押金和租金为必填项。',
    ],
  },
}
export default {
  name: 'AlertStep',
  props: {
    useDefault: {
      require: true,
      type: Boolean,
      default: false,
    },
    useDefaultNumber: {
      type: [Number, String],
      default: () => 1,
    },
    customContent: {
      type: Object,
      default: () => (null),
    },
    specialType: { // 类型（1-租赁方案，2-租赁订单）
      type: [Number, String],
      default: null,
    },
    specialRentCategory: { // 类别(租车，以租代购，司机合作模式)
      type: [Number, String],
      default: null,
    },
  },
  computed: {
    specialTitle() {
      let title = ''
      if (Number(this.specialType) === 1) {
        title = this.schemeContentMap[Number(this.specialRentCategory)]?.title || ''
      } else {
        title = this.orderContentMap[Number(this.specialRentCategory)]?.title || ''
      }
      return title
    },
    specialDescription() {
      let description = ''
      if (Number(this.specialType) === 1) {
        description = this.schemeContentMap[Number(this.specialRentCategory)]?.description || []
      } else {
        description = this.orderContentMap[Number(this.specialRentCategory)]?.description || []
      }
      return description
    },
  },
  data() {
    return {
      defaultData,
      schemeContentMap: { // 方案匹配文案
        1: { // 租车
          title: '② 确认支付计划',
          description: ['· 纯租模式下，押金和租金为必填项。'],
        },
        2: { // 以租代购
          title: '② 确认支付计划',
          description: ['· 以租代购模式下，首付款和租金为必填项。'],
        },
        3: { // 司机合作模式
          title: '② 确认支付计划',
          description: ['· 司机合作模式下，押金为必填项。'],
        },
      },
      orderContentMap: { // 订单匹配文案
        1: { // 租车
          title: '② 确认支付计划',
          description: [
            '· 纯租模式下，押金和租金为必填项，进入下一步前请先配置完成收款方案；',
            '· 收款项添加后会自动产生对应应收单。每一期的应收单会在收款起始日之前7天提前生成。',
          ],
        },
        2: { // 以租代购
          title: '② 确认支付计划',
          description: [
            '· 以租代购模式下，首付款和租金为必填项，进入下一步前请先配置完成收款方案；',
            '· 收款项添加后会自动产生对应应收单。每一期的应收单会在收款起始日之前7天提前生成。',
          ],
        },
        3: { // 司机合作模式
          title: '② 确认支付计划',
          description: [
            '· 司机合作模式下，押金为必填项，进入下一步前请先配置完成收款方案；',
            '· 收款项添加后会自动产生对应应收单。每一期的应收单会在收款起始日之前7天提前生成。',
          ],
        },
      },
    }
  },
}
</script>
<style scoped>
.margb{
  margin-bottom: 20px;
}
.title{
  color: #2E7EFF;
  font-weight: bold;
}
.description{
  text-indent: 15px;
  font-weight: bold;
}
</style>
